import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class WebDavFspConfig<T extends EMode = EMode.entity> {
  /** Alias: address */
  address?: string;
  /** Alias: username */
  username?: string;
  /** Alias: password */
  password?: string;

  __typename?: string;
}

const fields: FieldDefinitions<WebDavFspConfig> = {
  address: {
    alias: 'address',
  },
  username: {
    alias: 'username',
  },
  password: {
    alias: 'password',
  },
  __typename: {
    alias: '__typename',
  },
};

export const webDavFspConfigEntityDefinition: EntitiyDefinition<WebDavFspConfig> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'WebDavFspConfig',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
